function path(root, sublink) {
	return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

export const PATH_AUTH = {
	root: ROOTS_AUTH,
	login: path(ROOTS_AUTH, '/login'),
	register: path(ROOTS_AUTH, '/register'),
	loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
	registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
	verify: path(ROOTS_AUTH, '/verify'),
	resetPassword: path(ROOTS_AUTH, '/reset-password'),
	forgotPassword: path(ROOTS_AUTH, '/forgot-password'),
};

export const PATH_DASHBOARD = {
	root: ROOTS_DASHBOARD,
	main: {
		app: path(ROOTS_DASHBOARD, '/app'),
		forum: path(ROOTS_DASHBOARD, '/forum'),
		chats: path(ROOTS_DASHBOARD, '/chats'),
		announcement: path(ROOTS_DASHBOARD, '/announcement'),
		events: path(ROOTS_DASHBOARD, '/events'),
	},
	profiling: {
		create: path(ROOTS_DASHBOARD, '/profiling'),
	},
	analytics: {
		root: path(ROOTS_DASHBOARD, '/analytics'),
		disability: path(ROOTS_DASHBOARD, '/analytics/disability'),
		district: path(ROOTS_DASHBOARD, '/analytics/district'),
		// donation: path(ROOTS_DASHBOARD, '/analytics/donation'),
		assistance: path(ROOTS_DASHBOARD, '/analytics/assistance'),
		summary: path(ROOTS_DASHBOARD, '/analytics/summary'),
	},
	mapping: {
		main: path(ROOTS_DASHBOARD, '/mapping'),
	},
	members: {
		root: path(ROOTS_DASHBOARD, '/member'),
		list: path(ROOTS_DASHBOARD, '/member/list'),
		details: path(ROOTS_DASHBOARD, '/member/details'),
		edit: path(ROOTS_DASHBOARD, '/member/details/edit'),
		unverified: path(ROOTS_DASHBOARD, '/member/unverified/list'),
		unverifiedDetail: path(ROOTS_DASHBOARD, '/member/unverified/details'),
	},
	// events: {
	// 	root: path(ROOTS_DASHBOARD, '/events'),
	// },
	request: {
		root: path(ROOTS_DASHBOARD, '/request'),
		approved: path(ROOTS_DASHBOARD, '/request/approved'),
		pending: path(ROOTS_DASHBOARD, '/request/pending'),
		disapproved: path(ROOTS_DASHBOARD, '/request/disapproved'),
		add_request: path(ROOTS_DASHBOARD, '/request/add_request'),
	},
	assistive: {
		root: path(ROOTS_DASHBOARD, '/assistive'),
		create: path(ROOTS_DASHBOARD, '/assistive/create'),
		logs: path(ROOTS_DASHBOARD, '/assistive/logs'),
		list: path(ROOTS_DASHBOARD, '/assistive/list'),
		edit: path(ROOTS_DASHBOARD, '/assistive/edit'),
		// requestDetails: path(ROOTS_DASHBOARD, '/assistive/requestDetails'),
	},
};

// export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
